import React, { useMemo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import GenericFormDrawer from '../../../components/GenericFormDrawer';
import { addCandidatesToPool, fetchPoolOptions } from '../config/poolApi';

// "Aday Havuzuna Ekle" — aday listesi toplu aksiyonu ve aday detay sayfası AYNI
// çekmeceyi kullanır (`POST v1/ats-candidate-pools/{poolId}/members {candidateIds}`).
// Havuz üyeliği kişiye (LifecyclePersonId) bağlıdır; aynı kişi ikinci kez eklenirse
// sunucu tekilliği korur. Yalnız AT.Write çağırır (havuzlar tüm adayları içerir).
export default function AddToPoolDrawer({ open, onClose, candidateIds, onAdded }) {
  const { t } = useTranslation();
  const [pools, setPools] = useState([]);
  const count = (candidateIds || []).length;

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    fetchPoolOptions().then(({ items }) => { if (alive) setPools(items); });
    return () => { alive = false; };
  }, [open]);

  const schema = useMemo(() => [
    {
      name: 'summary',
      type: 'notice',
      content: pools.length === 0
        ? t('ats.candidatePool.noPoolsHint')
        : t('ats.candidatePool.addNotice', { count }),
      tone: pools.length === 0 ? 'warning' : undefined,
    },
    {
      name: 'poolId',
      label: t('ats.candidatePool.pool'),
      type: 'select',
      grid: 12,
      required: true,
      options: pools,
      idKey: 'id',
      labelKey: 'name',
    },
  ], [t, pools, count]);

  const handleSave = useCallback(async (values) => {
    if (!values.poolId || count === 0) return false;
    const result = await addCandidatesToPool(values.poolId, candidateIds);
    if (!result) return false;
    if (onAdded) onAdded(values.poolId, result);
    return true;
  }, [candidateIds, count, onAdded]);

  return (
    <GenericFormDrawer
      open={open}
      onClose={onClose}
      title={t('ats.candidatePool.addToPool')}
      schema={schema}
      initialValues={null}
      onSave={handleSave}
    />
  );
}
